import type { HandheldCurrentContentView, RosterAttendanceStatus } from '@/types/coaching'

export type HandheldListStatus = 'gradingPending' | 'approvalPending' | 'completed'

/**
 * 목록의 상태 라벨. 채점 대기는 오늘 등원 기록이 있는 원생(등원 중·하원)의 입력 가능한 미채점만 센다.
 * 승인 대기는 서버가 완료 승인 요건 충족으로 판정한 경우다.
 */
export function handheldListStatus(
  attendance: RosterAttendanceStatus,
  current: HandheldCurrentContentView | null | undefined,
): HandheldListStatus | null {
  if (!current) return null
  const attendedToday = attendance === 'IN' || attendance === 'OUT'
  if (attendedToday && current.pendingCount > 0) return 'gradingPending'
  if (current.completed) return 'completed'
  return attendedToday && current.readyToComplete ? 'approvalPending' : null
}

/** 채점 대기 필터 대상: 채점 대기와 완료 승인 대기를 함께 본다. */
export function isHandheldTodo(status: HandheldListStatus | null): boolean {
  return status === 'gradingPending' || status === 'approvalPending'
}
